import type { TMeters } from '@Anarchy/Engine/Math/Types';

export const METER: TMeters = 1 as TMeters;
